import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { OneDriveFspConfig } from './OneDriveFspConfig.entity';
import { WebDavFspConfig } from './WebDavFspConfig.entity';

export type FspConfigUnion<T extends EMode = EMode.entity> =
  T extends EMode.entity
    ? OneDriveFspConfig<T> | WebDavFspConfig<T>
    : {
        /** Alias: OneDriveFspConfig */
        oneDriveFspConfig?: OneDriveFspConfig<T>;
        /** Alias: WebDavFspConfig */
        webDavFspConfig?: WebDavFspConfig<T>;
      };

const fields: FieldDefinitions<FspConfigUnion<EMode.query>> = {
  oneDriveFspConfig: {
    alias: 'oneDriveFspConfig',
    entity: Entities.oneDriveFspConfig,
  },
  webDavFspConfig: {
    alias: 'webDavFspConfig',
    entity: Entities.webDavFspConfig,
  },
};

export const fspConfigUnionEntityDefinition: EntitiyDefinition<
  FspConfigUnion<EMode.query>
> = {
  kind: 'union',
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'FspConfigUnion',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
